module.exports = __webpack_public_path__ + "static/media/user-phone-redmi.d704bce1.svg";